import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';
import { Dataset, DatasetCsvReference } from '@/types/source-types';
import { normalizeDatasetCsvReference } from './normalize-dataset-csv-reference';

interface UpdateDatasetPayload {
  name?: string;
  description?: string;
  csv_object_keys?: DatasetCsvReference[];
}

interface UpdateDatasetResponse {
  dataset: Dataset;
}

export const updateDataset = async (
  collectionId: string,
  datasetId: string,
  payload: UpdateDatasetPayload,
) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const normalizedBody: Record<string, unknown> = {};

  if (payload.name !== undefined) {
    normalizedBody.name = payload.name;
  }

  if (payload.description !== undefined) {
    normalizedBody.description = payload.description;
  }

  if (payload.csv_object_keys !== undefined) {
    normalizedBody.csv_object_keys = payload.csv_object_keys.map((reference) =>
      normalizeDatasetCsvReference(reference),
    );
  }

  const response = await apiRequest<UpdateDatasetResponse>({
    url: `/collections/${orgId}/${collectionId}/datasets/${datasetId}`,
    method: 'PUT',
    target: 'platform',
    body: normalizedBody,
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to update dataset',
    };
  }

  return response?.data?.dataset;
};
